export const getCadeteColor = (cadeteId) => {
    if (cadeteId === undefined || cadeteId === null) return "#2D9CDB";

    const idString = String(cadeteId);
    let hash = 0;

    for (let i = 0; i < idString.length; i += 1) {
        hash = idString.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
};
